import isDebugging from './isDebugging';
export default function debuggerWhenDebugging() {
    if (isDebugging())
        debugger;
}
